import { z } from 'zod';
import { assertTypes, type NoNewFields } from './primitives';

/**
 * The Vercel cache tag of consumer-web's response to a hostname no venue has. A venue's own
 * responses are tagged with its id, so this one is purged whenever a hostname starts serving a venue
 * (a new site name or custom domain): it may have been requested, and cached as not found, before.
 */
export const NOT_FOUND_CACHE_TAG = 'not-found';

export const websiteConfigSchema = z.object({
  aboutUsContent: z.string().nullable().default(null),
  /** The venue's own domain (e.g. `mycafe.com.au`), set by OrderHub. `null`: none. */
  domainName: z.string().nullable().default(null),
  facebookUrl: z.string().nullable().default(null),
  instagramUrl: z.string().nullable().default(null),

  // Images
  aboutUsImageId: z.string().nullable().default(null),
  aboutUsImageUrl: z.string().nullable().default(null),
  bannerImageId: z.string().nullable().default(null),
  bannerImageUrl: z.string().nullable().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  restaurantId: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type WebsiteConfig = z.output<typeof websiteConfigSchema>;

/** Strict schema */
export const websiteConfigStrictSchema = websiteConfigSchema.extend({
  facebookUrl: z.url().nullable(),
  instagramUrl: z.url().nullable(),
});

/** Convex schema */
export const websiteConfigCvxSchema = websiteConfigSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  restaurantId: z.string(),
  updatedAt: z.number(),
});
export type WebsiteConfigCvx = z.output<typeof websiteConfigCvxSchema>;

assertTypes<NoNewFields<WebsiteConfig, WebsiteConfigCvx>>();
